export default "__VITE_ASSET__BFxpadz3__"